import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import { API_URL } from "../config";
import { UserContext } from "../context/UserContext";

function Profile() {
  const navigate = useNavigate();

  // Context se User Data aur Refresh Function nikalo
  const { user, loading, fetchUserData } = useContext(UserContext);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [alertModal, setAlertModal] = useState({ show: false, message: "", type: "success" });

  // Form State
  const [form, setForm] = useState({
    name: "",
    phone: ""
  });

  // User data aate hi Form update karo
  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        phone: user.mobile || ""
      });
    }
  }, [user]);

  const token = localStorage.getItem("token");

  // 🔥 CHECK LOCK STATUS
  // 1. Check agar user ek baar edit kar chuka hai (Local Lock)
  const hasEditedOnce = localStorage.getItem(`profile_locked_${user?._id}`) === "true";

  // 2. Name tab lock hoga jab: Ya toh 1 baar edit ho chuka ho, YA PAN verify/pending ho
  const isNameLocked = hasEditedOnce || ['VERIFIED', 'PENDING'].includes(user?.kyc?.pan?.status);

  // 3. Mobile tab lock hoga jab: Mobile pehle se database me ho, YA ek baar edit ho chuka ho
  const isPhoneLocked = Boolean(user?.mobile) || hasEditedOnce;

  /* =========================
      UPDATE PROFILE
    ========================= */
  const handleProfileUpdate = async () => {
    // Agar dono pehle se locked hain, toh save karne ki zaroorat nahi
    if (isNameLocked && isPhoneLocked) {
      setShowModal(false);
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/user/profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ name: form.name, mobile: form.phone })
      });
      const result = await res.json();

      // Dhyan dena: res.ok check kar rahe hain
      if (res.ok && result.data) {
        // 🔥 MAGIC STEP: Ek baar save hone ke baad hamesha ke liye Lock kar do
        localStorage.setItem(`profile_locked_${user?._id}`, "true");

        await fetchUserData();
        setShowModal(false);

        // 🔥 NAYA: Premium Success Modal
        setAlertModal({ show: true, message: "Profile Updated Successfully!", type: "success" });
      } else {
        // 🔥 NAYA: Premium Error Modal (Mobile number already linked yahi aayega)
        setAlertModal({ show: true, message: result.message || "Update failed", type: "error" });
      }
    } catch (err) {
      console.error("Update failed", err);
      // 🔥 NAYA: Network Error Modal
      setAlertModal({ show: true, message: "Network error, please try again.", type: "error" });
    } finally {
      setSaving(false);
    }
  };

  /* =========================
      AVATAR UPLOAD
  ========================= */
  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      // Isko bhi premium modal me daal diya
      setAlertModal({ show: true, message: "Only image files are allowed", type: "error" });
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("avatar", file);

    try {
      const res = await fetch(`${API_URL}/api/user/profile/avatar`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const result = await res.json();

      if (res.ok && result.data) {
        await fetchUserData();
        // 🔥 YAHAN KYA FIX: Purana alert hataya aur premium modal lagaya!
        setAlertModal({ show: true, message: "Profile Photo Updated Successfully!", type: "success" });
      }
    } catch (err) {
      console.error(err);
      setAlertModal({ show: true, message: "Failed to upload photo", type: "error" });
    } finally {
      setUploading(false);
    }
  };

  // SHIMMER LOADER IN MAROON THEME
  if (loading) return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh" }}>
      <div className="placeholder-glow" style={{ height: "160px", background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "20px", borderBottomRightRadius: "20px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}></div>
      <div className="container" style={{ marginTop: "-80px" }}>
        <div className="card border-0 shadow rounded-4 text-center p-3 mb-4 placeholder-glow">
          <div className="placeholder rounded-circle bg-secondary opacity-25 mx-auto" style={{ width: "110px", height: "110px" }}></div>
          <span className="placeholder col-6 mt-3 mb-2 bg-secondary opacity-25 rounded"></span>
          <span className="placeholder col-4 bg-secondary opacity-25 rounded"></span>
        </div>
        <div className="row mb-4 g-3 placeholder-glow">
          <div className="col-6"><div className="card border-0 shadow-sm rounded-4 h-100 p-4 bg-secondary opacity-10" style={{ height: '100px' }}></div></div>
          <div className="col-6"><div className="card border-0 shadow-sm rounded-4 h-100 p-4 bg-secondary opacity-10" style={{ height: '100px' }}></div></div>
        </div>
        <div className="card border-0 shadow-sm rounded-4 placeholder-glow p-3">
          <span className="placeholder col-12 bg-secondary opacity-10 mb-3 rounded" style={{ height: '40px' }}></span>
          <span className="placeholder col-12 bg-secondary opacity-10 mb-3 rounded" style={{ height: '40px' }}></span>
        </div>
      </div>
    </div>
  );

  if (!user) {
    navigate('/auth');
    return null;
  }

  const handleShare = async () => {
    const referralCode = user?.mobile ? `WIN${user.mobile.slice(-4)}` : "WIN112026";
    const shareData = {
      title: "Win11 Fantasy",
      text: `🏏 Join me on Win11 Fantasy & win big! \n\n🎁 Use my Code: *${referralCode}* to get ₹100 Bonus.\n\n👇 Download App Now:`,
      url: "https://win11fantasy.app"
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(`${shareData.text}\n${shareData.url}`);
        // Copy wale alert ko abhi touch nahi kiya, wo ok hai clipboard walo k liye
        alert(`✅ Code Copied: ${referralCode}\nShare it with your friends!`);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  const wallet = user.wallet || { deposited: 0, winnings: 0, bonus: 0 };

  return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh", paddingBottom: "80px" }}>

      {/* 1. HERO HEADER IN MAROON THEME */}
      <div
        className="position-relative w-100"
        style={{
          height: "160px",
          background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          boxShadow: "0 10px 20px rgba(128,0,0,0.15)"
        }}
      >
        <div className="p-3">
          <BackButton className="text-white bg-transparent border-0" />
        </div>
      </div>

      <div className="container" style={{ marginTop: "-80px" }}>

        {/* 2. AVATAR CARD */}
        <div className="card border-0 shadow rounded-4 text-center p-3 mb-4">
          <div className="position-relative d-inline-block mx-auto">
            <img
              src={user.avatar || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
              alt="User"
              className="rounded-circle border border-4 border-white shadow-sm"
              style={{ width: "110px", height: "110px", objectFit: "cover", background: "#fff" }}
            />
            <label className="position-absolute bottom-0 end-0 bg-dark text-white rounded-circle p-2 shadow" style={{ cursor: "pointer", width: "35px", height: "35px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              {uploading ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-camera-fill small"></i>}
              <input type="file" className="d-none" accept="image/*" onChange={handleAvatarUpload} />
            </label>
          </div>

          <h4 className="fw-bold mt-2 mb-0 text-capitalize">{user.name}</h4>
          <p className="text-muted small mb-2">{user.email}</p>

          <div>
            {user?.kyc?.pan?.status === 'VERIFIED' ? (
              <span className="badge bg-success-subtle text-success border border-success px-2 py-1 me-2 shadow-sm">
                <i className="bi bi-shield-fill-check me-1"></i> Verified
              </span>
            ) : (
              <span className="badge bg-danger-subtle text-danger border border-danger px-2 py-1 me-2 shadow-sm">
                <i className="bi bi-shield-fill-check me-1"></i> Unverified
              </span>
            )}

            <span className="badge bg-secondary-subtle text-dark border px-2 py-1">
              {user.role === "admin" ? "Admin" : "Player"}
            </span>
          </div>
        </div>

        {/* 3. PLAYER STATS GRID */}
        <div className="row mb-4 g-3">
          <div className="col-6">
            <div className="card border-0 shadow-sm rounded-4 text-white h-100 position-relative overflow-hidden"
              style={{ background: "linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%)" }}>
              <div className="card-body p-3">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-trophy-fill fs-5 me-2 opacity-50"></i>
                  <small className="fw-bold opacity-75" style={{ fontSize: '10px' }}>WON</small>
                </div>
                <h5 className="fw-bold mb-0">₹{wallet.winnings}</h5>
              </div>
              <i className="bi bi-currency-rupee position-absolute" style={{ fontSize: '5rem', opacity: '0.1', right: '-10px', bottom: '-20px' }}></i>
            </div>
          </div>

          <div className="col-6">
            <div className="card border-0 shadow-sm rounded-4 text-white h-100 position-relative overflow-hidden"
              style={{ background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)" }}>
              <div className="card-body p-3">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-controller fs-5 me-2 opacity-50"></i>
                  <small className="fw-bold opacity-75" style={{ fontSize: '10px' }}>MATCHES</small>
                </div>
                <h5 className="fw-bold mb-0">{user.totalMatches || 0}</h5>
              </div>
              <i className="bi bi-joystick position-absolute" style={{ fontSize: '5rem', opacity: '0.1', right: '-10px', bottom: '-20px' }}></i>
            </div>
          </div>
        </div>

        {/* REFER & EARN BANNER IN MAROON THEME */}
        <div className="card border-0 shadow-sm rounded-4 mb-4 text-white overflow-hidden position-relative"
             style={{ background: "linear-gradient(135deg, #A00000 0%, #6A0000 100%)" }}>
          <div className="card-body p-4 position-relative z-1">
            <h5 className="fw-bold">Invite Friends & Earn!</h5>
            <p className="small opacity-75 mb-3">Get ₹100 bonus for every friend who joins.</p>

            <button
              className="btn btn-light fw-bold rounded-pill btn-sm px-3 shadow-sm"
              onClick={handleShare}
              style={{ color: "#800000" }}
            >
              <i className="bi bi-share-fill me-1"></i> Share Code
            </button>
          </div>
          <div className="position-absolute bg-white rounded-circle opacity-10" style={{ width: '150px', height: '150px', top: '-50px', right: '-50px' }}></div>
          <i className="bi bi-gift-fill position-absolute text-white" style={{ fontSize: '6rem', opacity: '0.15', right: '10px', bottom: '-20px' }}></i>
        </div>

        {/* 5. DETAILS LIST */}
        <div className="card border-0 shadow-sm rounded-4 mb-4">
          <div className="list-group list-group-flush rounded-4">

            <div className="list-group-item p-3 d-flex justify-content-between align-items-center">
              <div>
                <i className="bi bi-envelope-fill text-secondary me-2"></i>
                <span className="text-secondary small">Email</span>
              </div>
              <span className="fw-bold text-dark">{user.email}</span>
            </div>

            {/* 🔥 MOBILE NUMBER ROW WITH "ADD MOBILE" LOGIC */}
            <div className="list-group-item p-3 d-flex justify-content-between align-items-center">
              <div>
                <i className="bi bi-telephone-fill text-success me-2"></i>
                <span className="text-secondary small">Mobile</span>
              </div>
              <span className="fw-bold text-dark">
                {user.mobile ? (
                  user.mobile
                ) : (
                  <span
                    className="small fw-bold text-decoration-none cursor-pointer hover-underline"
                    style={{ cursor: "pointer", color: "#800000" }}
                    onClick={() => setShowModal(true)}
                  >
                    + Add Mobile Number
                  </span>
                )}
              </span>
            </div>

            <button
              className="list-group-item list-group-item-action p-3 text-center fw-bold bg-light"
              style={{ color: "#800000" }}
              onClick={() => setShowModal(true)}
            >
              <i className="bi bi-pencil-square me-2"></i> Edit Profile Details
            </button>
          </div>
        </div>

        {/* COMPLETE KYC BUTTON IN MAROON THEME */}
        <button 
            className="btn w-100 py-3 rounded-pill fw-bold shadow-sm bg-white border-0 d-flex justify-content-center align-items-center gap-2" 
            style={{ color: "#800000" }}
            onClick={() => navigate("/verify-account")}
        >
          <i className="bi bi-shield-fill-check fs-5"></i> Complete KYC & Get Verified
        </button>

      </div>

      {/* ================= MODAL IN MAROON THEME ================= */}
      {showModal && (
        <>
          <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.6)" }}></div>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">

                <div className="modal-header border-0 text-white p-4" style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)" }}>
                  <div>
                    <h5 className="modal-title fw-bold mb-1">Edit Profile</h5>
                    <p className="mb-0 small opacity-75">Update your details quickly</p>
                  </div>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                </div>

                <div className="modal-body p-4 bg-light">

                  {/* 🔥 WARNING ALERT FOR ONE-TIME CHANGE */}
                  <div className="alert alert-warning py-2 small border-0 mb-4 shadow-sm rounded-3 text-center">
                    <i className="bi bi-exclamation-triangle-fill me-1"></i>
                    Name and Mobile number can be changed <strong>only one time</strong>.
                  </div>

                  {/* NAME FIELD */}
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control rounded-3 border-0 shadow-sm fw-bold"
                      id="floatingName"
                      placeholder="Enter Name"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      readOnly={isNameLocked}
                      style={{
                        height: "55px",
                        backgroundColor: isNameLocked ? "#e9ecef" : "#fff",
                        color: isNameLocked ? "#6c757d" : "#000",
                        cursor: isNameLocked ? "not-allowed" : "text"
                      }}
                    />
                    <label htmlFor="floatingName" className="text-muted"><i className="bi bi-person-fill me-2"></i> Full Name</label>
                  </div>

                  {/* MOBILE FIELD */}
                  <div className="form-floating mb-4">
                    <input
                      type="tel"
                      className="form-control rounded-3 border-0 shadow-sm fw-bold"
                      id="floatingPhone"
                      placeholder="Enter Mobile"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      readOnly={isPhoneLocked}
                      style={{
                        height: "55px",
                        backgroundColor: isPhoneLocked ? "#e9ecef" : "#fff",
                        color: isPhoneLocked ? "#6c757d" : "#000",
                        cursor: isPhoneLocked ? "not-allowed" : "text"
                      }}
                    />
                    <label htmlFor="floatingPhone" className="text-muted"><i className="bi bi-phone-fill me-2"></i> Mobile Number</label>
                  </div>

                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="btn btn-lg rounded-pill fw-bold shadow-sm text-white"
                      onClick={handleProfileUpdate}
                      disabled={saving || (isNameLocked && isPhoneLocked)} 
                      style={{ background: (isNameLocked && isPhoneLocked) ? "#ccc" : "linear-gradient(135deg, #800000 0%, #4A0000 100%)", border: "none" }}
                    >
                      {saving ? (<><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>) : ("Save Changes")}
                    </button>
                    <button type="button" className="btn btn-link text-decoration-none text-muted mt-2" onClick={() => setShowModal(false)}>Cancel</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* 🔥 PREMIUM ALERT MODAL 🔥 */}
      {alertModal.show && (
        <>
          <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1080 }}></div>
          <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1090 }}>
            <div className="modal-dialog modal-dialog-centered px-4">
              <div className="modal-content border-0 shadow-lg rounded-4 p-4 text-center animate-bounce">

                <div className={`mb-3 text-${alertModal.type === 'error' ? 'danger' : 'success'}`}>
                  <i className={`bi bi-${alertModal.type === 'error' ? 'x-circle-fill' : 'check-circle-fill'} display-1`}></i>
                </div>

                <h4 className="fw-bold mb-2 text-dark">
                  {alertModal.type === 'error' ? 'Oops!' : 'Success!'}
                </h4>

                <p className="text-muted mb-4 px-2" style={{ fontSize: "15px" }}>
                  {alertModal.message}
                </p>

                <button
                  className={`btn w-100 rounded-pill py-3 fw-bold shadow-sm text-white`}
                  style={{ background: alertModal.type === 'error' ? '#dc3545' : '#198754' }}
                  onClick={() => setAlertModal({ show: false, message: "", type: "success" })}
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Animation CSS */}
      <style>{`
                .animate-bounce { animation: bounceIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) both; }
                @keyframes bounceIn {
                    0% { transform: scale(0.5); opacity: 0; }
                    80% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>

    </div>
  );
}

export default Profile;